"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var PolicyVersionTree_1 = require("./PolicyVersionTree");
var components_1 = require("@athena-portal/components");
var Page_1 = require("../Page");
var services_1 = require("@falcon/services");
var react_router_dom_1 = require("react-router-dom");
var VulnerableCustomerActionsTree_1 = require("./VulnerableCustomerActionsTree");
var RenewalInviteTree_1 = require("./renewals/RenewalInviteTree");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var Tree_1 = require("../../components/Tree");
var moment = require("moment/moment");
var PoliciesTree = /** @class */ (function (_super) {
    __extends(PoliciesTree, _super);
    function PoliciesTree(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPoliciesTree = function (policies) {
            if (!policies || policies.length === 0) {
                return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Policies not found!" });
            }
            var policiesTree = [];
            for (var _i = 0, policies_1 = policies; _i < policies_1.length; _i++) {
                var policy = policies_1[_i];
                var isActivePolicy = _this.isActivePolicy(policy);
                var isPolicyFit = policy.products.includes(services_1.ProductsEnum.WOLF_MOTOR) || policy.products.includes(services_1.ProductsEnum.HOME);
                var paymentLinkProps = {
                    to: "/customers/".concat(_this.props.customerReferenceNumber, "/payments?policy=").concat(policy.number),
                    title: "Invoices and payments",
                    className: "icon-button fas fa-file-invoice-dollar ml-2",
                    id: "invoicePageAnnual"
                };
                var vulnerableCustomerLinkProps = {
                    to: "/customers/".concat(_this.props.customerReferenceNumber, "/vulnerableCustomer/additionalSupportHistory/").concat(policy.number),
                    title: "View additional support record history",
                    className: "ml-2",
                    id: "vulnerableCustomerRecordHistory"
                };
                policiesTree.push((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { defaultOpen: true, label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("i", { className: "far fa-file-alt" }), ' ', policy.number, ' ', "[", _this.getPolicyStartDateGMT(policy), "] \u2192 [", _this.getPolicyEndDateGMT(policy), "]", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({}, paymentLinkProps))] }), children: [_this.props.vulnerableCustomerFlag && isPolicyFit && (isActivePolicy || _this.policyHasMtcVersion(policy)) && ((0, jsx_runtime_1.jsxs)("div", { className: "mb-2", children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({}, vulnerableCustomerLinkProps, { children: "View additional support record history" })), (0, jsx_runtime_1.jsx)(VulnerableCustomerActionsTree_1.default, { customerId: _this.props.customerReferenceNumber, policyNumber: policy.number, policyVersionId: policy.versions[policy.versions.length - 1].policyVersionId, policyVersionNumber: policy.versions[policy.versions.length - 1].policyVersionNumber, onActionChange: _this.props.onActionChange }, "Vulnerable customer actions tree")] })), _this.renderPolicyVersionTrees(policy)] }, policy.number));
                {
                    _this.props.renewalProposals && _this.props.renewalProposals.length !== 0 && _this.renderRenewalInvites(policiesTree, policy, _this.props.renewalProposals);
                }
            }
            return policiesTree;
        };
        _this.renderRenewalInvites = function (policiesTree, policy, renewals) {
            return renewals.filter(function (renewal) { return renewal.agreementNumber === policy.number; }).forEach(function (renewal) { return (policiesTree.push((0, jsx_runtime_1.jsx)(RenewalInviteTree_1.default, { interaction: renewal, customerReferenceNumber: _this.props.customerReferenceNumber }, "renewal-".concat(renewal.agreementNumber)))); });
        };
        _this.getSubscription = function (policies) {
            return policies === null || policies === void 0 ? void 0 : policies.filter(function (p) { return p.products.includes(services_1.ProductsEnum.MOTOR) || p.products.includes(services_1.ProductsEnum.RENTERS); });
        };
        _this.getAnnualPolicies = function (policies) {
            return policies === null || policies === void 0 ? void 0 : policies.filter(function (p) { return p.products.includes(services_1.ProductsEnum.WOLF_MOTOR); });
        };
        _this.getAnnualHomePolicies = function (policies) {
            return policies === null || policies === void 0 ? void 0 : policies.filter(function (p) { return p.products.includes(services_1.ProductsEnum.HOME); });
        };
        _this.getPolicyStartDateGMT = function (policy) {
            var startDate = policy.versions[0].startDate;
            return (0, commonFunctions_1.formatDate)(startDate);
        };
        _this.getPolicyEndDateGMT = function (policy) {
            var lastElement = policy.versions.length - 1;
            var endDate = policy.versions[lastElement].endDate;
            return (0, commonFunctions_1.formatDate)(endDate);
        };
        _this.renderPolicyVersionTrees = function (policy) {
            var policyVersionTrees = [];
            policy.versions.forEach(function (policyVersion, index) {
                var policyVersionNotActive = policyVersion.endDate != null && moment.utc(policyVersion.endDate, moment.ISO_8601).isBefore(moment(), 'day');
                policyVersionTrees.push((0, jsx_runtime_1.jsx)(PolicyVersionTree_1.default, __assign({ policy: policy, policyVersion: policyVersion, isMTC: policyVersion.status === "MTC" || policyVersionNotActive, index: index }, _this.props, { showLoader: _this.props.showLoader, hideLoader: _this.props.hideLoader }), policyVersion.policyVersionNumber));
            });
            return policyVersionTrees;
        };
        _this.state = {};
        return _this;
    }
    PoliciesTree.prototype.render = function () {
        var subscription = this.getSubscription(this.props.policies);
        var annualPolicies = this.getAnnualPolicies(this.props.policies);
        var annualHomePolicies = this.getAnnualHomePolicies(this.props.policies);
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [subscription && subscription.length > 0 && ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { defaultOpen: true, label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Subscription ", (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/customers/".concat(this.props.customerReferenceNumber, "/payments"), title: "Invoices and payments", className: "icon-button fas fa-file-invoice-dollar ml-2", id: "invoicePageSubscription" })] }), children: this.renderPoliciesTree(subscription) })), annualPolicies && annualPolicies.length > 0 && ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { defaultOpen: true, label: "".concat(services_1.resourcesHelper.PRODUCT, " Car Insurance Policies"), children: this.renderPoliciesTree(annualPolicies) })), annualHomePolicies && annualHomePolicies.length > 0 && ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { defaultOpen: true, label: "".concat(services_1.resourcesHelper.PRODUCT, " Home Insurance policies"), children: this.renderPoliciesTree(annualHomePolicies) }))] }));
    };
    PoliciesTree.prototype.isActivePolicy = function (policy) {
        var isPolicyFit = (policy.products.includes(services_1.ProductsEnum.WOLF_MOTOR) || policy.products.includes(services_1.ProductsEnum.HOME)) && !this.policyHasMtcVersion(policy);
        var versions = isPolicyFit ? policy.versions : undefined;
        var newestPolicyVersion = versions ? versions[versions.length - 1] : undefined;
        return !!newestPolicyVersion;
    };
    PoliciesTree.prototype.policyHasMtcVersion = function (policy) {
        return policy.versions.some(function (version) { return version.status === "MTC"; });
    };
    PoliciesTree.contextType = Page_1.PageContext;
    PoliciesTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], PoliciesTree);
    return PoliciesTree;
}(React.Component));
exports.default = PoliciesTree;
//# sourceMappingURL=PoliciesTree.js.map